import { Spinner, Wrapper } from "./Spinner.styles";

const Loading = () =>{
    return(
        <Wrapper>
            <Spinner></Spinner>
        </Wrapper>
    )
}

export default Loading;